<!-- <div class="order-list-stiky-header" *ngIf="db.scroll_top && false">
  <div class="search__filters d__flex">
    <div class="top__bar">
      <ion-searchbar [(ngModel)]="db.searchCustomer" (ionChange)="search_customers.emit($event)"></ion-searchbar>
    </div>
    <div class="d__flex main_sort">
      <ion-button *ngIf="!db.ismobile && false" slot="end" class="headerButton" (click)="new_customer.emit($event)">
        <ion-icon src="assets/icons/add.svg"></ion-icon>New Discount
      </ion-button>
    </div>
  </div>
</div> -->
<div class="Fields-5" *ngIf="!db.ismobile">
  <div class="table__data d__flex table__header">
    <div class="txt-center">
      <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
    </div>
    <div class="">Discount Name</div>
    <div class="">Discount Type</div>
    <div class="">Valid From</div>
    <div class="">Valid Till</div>
  </div>
  <div [ngClass]="db.scroll_top ? 'orderss__list' : 'orderss_list'" #scrollMe *ngIf="!db.ismobile && discount_list.length != 0" (scroll)="onScroll($event)">
    <div class="main-item mouse" (click)="order_list(item)" *ngFor="let item of discount_list;let i =index" (click)="edit_discount(item ,i)">
      <div class="table__data  d__flex table__items">
        <div class="txt-center">
          <ion-checkbox [checked]="check_box" class="check__box box_icon"></ion-checkbox>
        </div>
        <div class="order_id txt_capital">
          <p class="">{{item.name1}}</p>
        </div>
        <div>{{item.discount_type}}</div>
        <div>{{item.start_date | date}}</div>
        <div>{{item.end_date | date}}</div>
      </div>
    </div>
  </div>
</div>
<div class="pl10" *ngIf="db.searchCustomer && discount_list.length == 0">
  <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
    <ion-label>
      <p>
        <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>
</div>
